module.exports = `:root {
  --primitiveColorPrimary400: #066c42;
  --primitiveColorPrimary800: #0ce38b;
  --primitiveColorPrimary850: #0df294;
  --primitiveColorPrimary900: #7afac5;
  --primitiveColorPrimary950: #c5fde6;
  --primitiveColorPrimary975: #e3fef3;
  --primitiveColorSecondary400: #106a65;
  --primitiveColorSecondary710: #1dc4bc;
  --primitiveColorSecondary850: #92e2df;
  --primitiveColorSecondary900: #b8ecea;
  --primitiveColorSecondary950: #dcf6f5;
  --primitiveColorSecondary975: #eefafa;
  --primitiveColorDark25: #000c0b;
  --primitiveColorDark50: #001413;
  --primitiveColorDark100: #01201e;
  --primitiveColorDark200: #173533;
  --primitiveColorDark300: #314b4a;
  --primitiveColorMono500: #777777;
  --primitiveColorMono650: #9e9e9e;
  --primitiveColorMono750: #b9b9b9;
  --primitiveColorMono850: #d4d4d4;
  --primitiveColorMono900: #e2e2e2;
  --primitiveColorMono950: #f1f1f1;
  --primitiveColorMono975: #f8f8f8;
  --primitiveColorMono1000: #ffffff;
  --primitiveColorNotice956: #ebff00;
  --primitiveColorNegative575: #f74c49;
  --primitiveTypographyFontFamily: Averta, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --primitiveTypographyTypescaleDesktop1: 2.8125rem;
  --primitiveTypographyTypescaleDesktop2: 1.875rem;
  --primitiveTypographyTypescaleDesktop3: 1.5625rem;
  --primitiveTypographyTypescaleDesktop4: 1.25rem;
  --primitiveTypographyTypescaleDesktop5: 0.9375rem;
  --primitiveTypographyTypescaleMobile1: 2.25rem;
  --primitiveTypographyTypescaleMobile2: 1.5rem;
  --primitiveTypographyTypescaleMobile3: 1.25rem;
  --primitiveTypographyTypescaleMobile4: 1rem;
  --primitiveTypographyTypescaleMobile5: 0.75rem;
}
`;